import React from 'react';
import { Check } from 'lucide-react';

const CheckoutProgress = ({ currentStep }) => {
  const steps = [
    { number: 1, label: 'Choose Plan' },
    { number: 2, label: 'Payment' },
    { number: 3, label: 'Complete' },
  ];

  return (
    <div className="hidden md:flex items-center gap-2">
      {steps.map((step, index) => (
        <React.Fragment key={step.number}>
          <div className="flex items-center gap-2">
            <div className={`flex items-center justify-center w-8 h-8 rounded-full font-semibold text-sm transition-all ${
              currentStep > step.number
                ? 'bg-green-500 text-white'
                : currentStep === step.number
                ? 'bg-blue-600 text-white'
                : 'bg-gray-200 text-gray-500'
            }`}>
              {currentStep > step.number ? (
                <Check className="h-4 w-4" />
              ) : (
                step.number
              )}
            </div>
            <span className={`text-sm font-medium hidden lg:inline ${
              currentStep >= step.number ? 'text-gray-900' : 'text-gray-500'
            }`}>
              {step.label}
            </span>
          </div>
          
          {index < steps.length - 1 && (
            <div className={`w-12 h-0.5 ${
              currentStep > step.number ? 'bg-green-500' : 'bg-gray-200'
            }`} />
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default CheckoutProgress;